import { isCustomRolesEnabled, nonEnterpriseRoles } from '@gonfalon/dogfood-flags/dogfood-flags';

import type { Member } from './types';

export function hasCustomRoles(member: Member) {
  // Mirrors the backend's computeBaseAccessChecker gate (internal/access_checker/builders.go):
  // custom roles are honored when custom.roles OR non-enterprise-roles is enabled, with no
  // account.enable.teams requirement. A stricter check here misclassifies custom-role members
  // as their base role and denies actions the backend allows (SEC-8935).
  return (isCustomRolesEnabled() || nonEnterpriseRoles()) && (member.customRoles?.length ?? 0) > 0;
}
